module.exports = __webpack_public_path__ + "h5/img/Z3-start.51ef79e9.jpg";